import { Step } from '../../api/providers';

export enum AnalyticsEvent {
  VIEWED,
  COMPLETED,
  FAILED,
}

export type TrackingEventsProp = Partial<Record<AnalyticsEvent, string>>;

export const ONBOARDING_TRACKING_EVENTS: { [key in Step]?: TrackingEventsProp } = {
  [Step.Signup]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Sign Up Page Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Sign Up Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Sign Up Failed',
  },
  [Step.Address]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Location Screen Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Location Screen Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Location Screen Failed',
  },
  [Step.Availability]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Availability Screen Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Availability Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Availability Failed',
  },
  [Step.GalleryImage]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Add Photos Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Add Photos Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Add Photos Failed',
  },
  [Step.PaymentsOnboarding]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Payments Onboarding Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Payments Onboarding Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Payments Onboarding Failed',
  },
  [Step.IdentityVerify]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Verify Information Screen Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Verify Information Screen Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Verify Information Screen Failed',
  },
  [Step.MailingAddress]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Mailing Address Screen Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Mailing Address Screen Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Mailing Address Screen Failed',
  },
  [Step.BankAccount]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Bank Account Screen Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Bank Account Screen Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Bank Account Screen Failed',
  },
  [Step.ProfilePhoto]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Profile Picture Screen Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Profile Picture Screen Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Profile Picture Screen Failed',
  },
  [Step.Services]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Services Screen Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Services Screen Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Services Screen Failed',
  },
  [Step.SetupSubscription]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Setup Subscription Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Setup Subscription Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Setup Subscription Failed',
  },
  [Step.PlanSelect]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Select Plan Screen Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Select Plan Screen Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Select Plan Screen Failed',
  },
  [Step.GoalSelect]: {
    [AnalyticsEvent.VIEWED]: 'Pro Onboarding Select Goal Screen Viewed',
    [AnalyticsEvent.COMPLETED]: 'Pro Onboarding Select Goal Screen Completed',
    [AnalyticsEvent.FAILED]: 'Pro Onboarding Select Goal Screen Failed',
  },
};
